import { useEffect } from 'react';
import { useAuthEvents } from './useAuthEvents';

export const useRefreshToken = (scopes: string[], redirectUri: string) => {
  const { getAuthToken } = useAuthEvents();
  useEffect(() => {
    const interval = setInterval(() => getAuthToken(scopes, redirectUri), 59 * 60 * 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);
};
